import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

interface ITooltipContent {
  text: string;
  closeHandler: (event: any) => void;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "grid",
    maxWidth: theme.spacing(44),
    gridTemplateColumns: `1fr 14px`,
    gridGap: theme.spacing(3),
    padding: "18px 16px 14px 16px",
  },
  text: {
    display: "inline-block",
    fontSize: "12px",
    lineHeight: 1.33,
  },
  closeButton: {
    cursor: "pointer",
    color: "#535358",
    fontSize: 14,
  },
}));

export default function TooltipContent({
  text,
  closeHandler,
}: ITooltipContent) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <Typography className={classes.text}>{text}</Typography>
      </div>
      <div>
        <CloseIcon className={classes.closeButton} onClick={closeHandler} />
      </div>
    </div>
  );
}
